"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MINDSET_MESSAGE_ATTACHMENT_POLICIES = exports.MINDSET_MESSAGE_ATTACHMENT_UPLOAD_READINESS_VERSION = exports.MINDSET_MESSAGE_ATTACHMENT_ACCESSIBILITY_VERSION = exports.MINDSET_MESSAGE_ATTACHMENT_TRANSFER_VERSION = exports.MINDSET_MESSAGE_ATTACHMENT_PRESENTATION_VERSION = exports.MINDSET_MESSAGE_ATTACHMENT_POLICY_VERSION = exports.TERMS_TENANT_CONFIG = exports.TERMS_ENTITLEMENT_MANIFEST = exports.TERMS_MINDSET_CAPABILITIES = exports.MINDSET_LAB_TENANT_CONFIG = exports.MINDSET_LAB_ENTITLEMENT_MANIFEST = exports.MINDSET_LAB_CAPABILITIES = exports.MINDSET_CONSENTED_CALL_RECORDING_FIXTURE = exports.MINDSET_V2_LIMITS = exports.MINDSET_V2_CONTRACT_VERSION = exports.MINDSET_V2_API_VERSION = exports.MINDSET_TYPING_UX = exports.MINDSET_DEFAULT_REACTION_EMOJIS = exports.MINDSET_PROFILE_AVATAR_V1_CONTRACT_VERSION = exports.MINDSET_ACCOUNTS_V2_CONTRACT_VERSION = exports.MINDSET_ENTITLEMENT_MANIFEST_VERSION = exports.MINDSET_GROUP_CALL_INVITE_PLAN_VERSION = exports.TERMS_TENANT_ID = exports.MINDSET_LAB_TENANT_ID = exports.MINDSET_API_VERSION = void 0;
exports.isMindsetCallSession = isMindsetCallSession;
exports.isMindsetGroupCallInvitePlan = isMindsetGroupCallInvitePlan;
exports.isMindsetCallEvent = isMindsetCallEvent;
exports.isMindsetConversation = isMindsetConversation;
exports.isMindsetMessage = isMindsetMessage;
exports.isMindsetMessageReplyContext = isMindsetMessageReplyContext;
exports.isMindsetExternalContentReference = isMindsetExternalContentReference;
exports.isMindsetMessageFolder = isMindsetMessageFolder;
exports.isMindsetMessageAttachment = isMindsetMessageAttachment;
exports.buildMindsetMessageAttachmentUploadReadiness = buildMindsetMessageAttachmentUploadReadiness;
exports.isMindsetMessageAttachmentUploadReadiness = isMindsetMessageAttachmentUploadReadiness;
exports.getMindsetMessageAttachmentPolicy = getMindsetMessageAttachmentPolicy;
exports.normalizeMindsetMessageAttachmentContentType = normalizeMindsetMessageAttachmentContentType;
exports.evaluateMindsetMessageAttachmentPolicy = evaluateMindsetMessageAttachmentPolicy;
exports.deriveMindsetMessageAttachmentPresentationState = deriveMindsetMessageAttachmentPresentationState;
exports.deriveMindsetMessageAttachmentTransferState = deriveMindsetMessageAttachmentTransferState;
exports.deriveMindsetMessageAttachmentAccessibilityState = deriveMindsetMessageAttachmentAccessibilityState;
exports.isMindsetMessageReceipt = isMindsetMessageReceipt;
exports.isMindsetMessageReaction = isMindsetMessageReaction;
exports.isMindsetMessageReport = isMindsetMessageReport;
exports.isMindsetContactDiscoveryReport = isMindsetContactDiscoveryReport;
exports.isMindsetUserProfile = isMindsetUserProfile;
exports.isMindsetContactDiscoverySettings = isMindsetContactDiscoverySettings;
exports.isMindsetAccountSettings = isMindsetAccountSettings;
exports.isMindsetConversationNotificationSettings = isMindsetConversationNotificationSettings;
exports.isMindsetContactMatch = isMindsetContactMatch;
exports.isMindsetMessageEvent = isMindsetMessageEvent;
exports.isMindsetMessageReceiptEvent = isMindsetMessageReceiptEvent;
exports.isMindsetConversationPresenceEvent = isMindsetConversationPresenceEvent;
exports.isMindsetRealtimeEvent = isMindsetRealtimeEvent;
exports.createMindsetIdempotencyKey = createMindsetIdempotencyKey;
exports.normalizeMindsetContactHandleValue = normalizeMindsetContactHandleValue;
exports.createMindsetContactHandle = createMindsetContactHandle;
exports.isMindsetContactHandle = isMindsetContactHandle;
exports.MINDSET_API_VERSION = "v1";
exports.MINDSET_LAB_TENANT_ID = "mindset-lab";
exports.TERMS_TENANT_ID = "terms";
exports.MINDSET_GROUP_CALL_INVITE_PLAN_VERSION = "mindset-group-call-invite-plan/v1";
exports.MINDSET_ENTITLEMENT_MANIFEST_VERSION = "mindset-entitlements/v1";
exports.MINDSET_ACCOUNTS_V2_CONTRACT_VERSION = "mindset-accounts/v2";
exports.MINDSET_PROFILE_AVATAR_V1_CONTRACT_VERSION = "mindset-profile-avatar/v1";
/**
 * Default quick-reaction catalog. Tenants may curate via the entitlement
 * manifest (features.reactions.emojiCatalog + catalogMode); the server only
 * enforces the catalog in CATALOG_ONLY mode.
 */
exports.MINDSET_DEFAULT_REACTION_EMOJIS = Object.freeze([
    "❤️",
    "👍",
    "👎",
    "😂",
    "😮",
    "😢",
    "🙏",
    "🔥",
]);
/**
 * Shared typing-indicator UX timings. All clients consume these; no client
 * hardcodes numbers. A MESSAGE_SENT from the same actor within stopGraceMs
 * replaces the typing bubble in place.
 */
exports.MINDSET_TYPING_UX = Object.freeze({
    senderDebounceMs: 1200,
    receiverSelfExpiryMs: 3500,
    stopGraceMs: 2000,
    leaseSeconds: 8,
});
/** Additive first-party contracts. Existing mindset/v1 contracts remain unchanged. */
exports.MINDSET_V2_API_VERSION = "v2";
exports.MINDSET_V2_CONTRACT_VERSION = "mindset-communications/v2";
exports.MINDSET_V2_LIMITS = Object.freeze({
    maxGroupCallParticipants: 16,
    maxScheduledCallInvitees: 15,
    maxAttachmentsPerMessage: 10,
    attachmentByteSize: Object.freeze({
        IMAGE: 10 * 1024 * 1024,
        VIDEO: 80 * 1024 * 1024,
        AUDIO: 16 * 1024 * 1024,
        FILE: 25 * 1024 * 1024,
    }),
});
var consented_call_recording_fixture_1 = require("./consented-call-recording.fixture");
Object.defineProperty(exports, "MINDSET_CONSENTED_CALL_RECORDING_FIXTURE", { enumerable: true, get: function () { return consented_call_recording_fixture_1.MINDSET_CONSENTED_CALL_RECORDING_FIXTURE; } });
exports.MINDSET_LAB_CAPABILITIES = {
    messaging: true,
    mediaRequests: true,
    audioCalls: true,
    videoCalls: true,
    callRequests: true,
    oneTimeCallApprovals: true,
    reusableCallApprovals: true,
    realtime: {
        websocketEvents: true,
        directPush: true,
        androidTelecom: true,
        iosCallKit: true,
        liveKit: true,
    },
};
exports.MINDSET_LAB_ENTITLEMENT_MANIFEST = Object.freeze({
    manifestVersion: exports.MINDSET_ENTITLEMENT_MANIFEST_VERSION,
    issuedAt: "2026-09-01T00:00:00.000Z",
    features: Object.freeze({
        typingPresence: Object.freeze({ enabled: true }),
        replies: Object.freeze({ enabled: true }),
        reactions: Object.freeze({
            enabled: true,
            emojiCatalog: exports.MINDSET_DEFAULT_REACTION_EMOJIS,
            catalogMode: "FULL_PICKER",
        }),
        liveReactions: Object.freeze({ enabled: true, maxPer10s: 12 }),
        messageEdit: Object.freeze({ enabled: true, windowSeconds: 86400 }),
        undoSend: Object.freeze({ enabled: true, graceSeconds: 60 }),
        messageDelete: Object.freeze({ enabled: true, windowSeconds: 86400 }),
        voiceNotes: Object.freeze({ enabled: true, maxDurationMs: 600000 }),
        voicemail: Object.freeze({
            enabled: true,
            maxGreetings: 5,
            maxMessageDurationMs: 180000,
            retentionDays: 30,
        }),
        videoVoicemail: Object.freeze({ enabled: false }),
        consentControls: Object.freeze({
            enabled: true,
            defaults: Object.freeze({
                voiceCall: false,
                videoCall: false,
                photoMessage: false,
                videoMessage: false,
            }),
        }),
        // Phase 2B profile-user keychain. Deliberately ABSENT from the TERMS
        // manifest: TERMS tenants 403 on every keychain surface (fail closed)
        // and see zero behavior change.
        profileKeychain: Object.freeze({ enabled: true }),
        // Phase 2C Team Management Dashboard. A SEPARATE key from
        // profileKeychain on purpose: profileKeychain is already ON in
        // production, so reusing it would ship 2C to real owners the instant the
        // gateway deploys, with no staged flip — and this is the one wave that
        // hands out call-answering permissions. Flipping teamManagement off
        // hides the dashboard without disturbing any live line. Also
        // deliberately ABSENT from the TERMS manifest.
        teamManagement: Object.freeze({ enabled: true }),
    }),
});
exports.MINDSET_LAB_TENANT_CONFIG = {
    id: exports.MINDSET_LAB_TENANT_ID,
    displayName: "Mindset",
    customerApp: "mindset",
    apiNamespace: "mindset/v1",
    mediaProvider: "livekit",
    capabilities: exports.MINDSET_LAB_CAPABILITIES,
    manifest: exports.MINDSET_LAB_ENTITLEMENT_MANIFEST,
};
exports.TERMS_MINDSET_CAPABILITIES = {
    messaging: false,
    mediaRequests: true,
    audioCalls: true,
    videoCalls: true,
    callRequests: true,
    oneTimeCallApprovals: true,
    reusableCallApprovals: true,
    realtime: {
        websocketEvents: true,
        directPush: true,
        androidTelecom: true,
        iosCallKit: true,
        liveKit: true,
    },
};
/**
 * TERMS has capabilities.messaging=false, so every messaging-dependent
 * feature is disabled; call-side voicemail and consent controls stay on.
 */
exports.TERMS_ENTITLEMENT_MANIFEST = Object.freeze({
    manifestVersion: exports.MINDSET_ENTITLEMENT_MANIFEST_VERSION,
    issuedAt: "2026-09-01T00:00:00.000Z",
    features: Object.freeze({
        typingPresence: Object.freeze({ enabled: false }),
        replies: Object.freeze({ enabled: false }),
        reactions: Object.freeze({ enabled: false }),
        liveReactions: Object.freeze({ enabled: false }),
        messageEdit: Object.freeze({ enabled: false }),
        undoSend: Object.freeze({ enabled: false }),
        messageDelete: Object.freeze({ enabled: false }),
        voiceNotes: Object.freeze({ enabled: false }),
        voicemail: Object.freeze({
            enabled: true,
            maxGreetings: 5,
            maxMessageDurationMs: 180000,
            retentionDays: 30,
        }),
        videoVoicemail: Object.freeze({ enabled: false }),
        consentControls: Object.freeze({
            enabled: true,
            defaults: Object.freeze({
                voiceCall: false,
                videoCall: false,
                photoMessage: false,
                videoMessage: false,
            }),
        }),
    }),
});
exports.TERMS_TENANT_CONFIG = {
    id: exports.TERMS_TENANT_ID,
    displayName: "TERMS",
    customerApp: "terms",
    apiNamespace: "mindset/v1",
    mediaProvider: "livekit",
    capabilities: exports.TERMS_MINDSET_CAPABILITIES,
    manifest: exports.TERMS_ENTITLEMENT_MANIFEST,
};
exports.MINDSET_MESSAGE_ATTACHMENT_POLICY_VERSION = "mindset-message-attachment-policy/v1";
exports.MINDSET_MESSAGE_ATTACHMENT_PRESENTATION_VERSION = "mindset-message-attachment-presentation/v1";
exports.MINDSET_MESSAGE_ATTACHMENT_TRANSFER_VERSION = "mindset-message-attachment-transfer/v1";
exports.MINDSET_MESSAGE_ATTACHMENT_ACCESSIBILITY_VERSION = "mindset-message-attachment-accessibility/v1";
exports.MINDSET_MESSAGE_ATTACHMENT_UPLOAD_READINESS_VERSION = "mindset-message-attachment-upload-readiness/v1";
const MINDSET_MEBIBYTE = 1024 * 1024;
exports.MINDSET_MESSAGE_ATTACHMENT_POLICIES = Object.freeze({
    IMAGE: Object.freeze({
        kind: "IMAGE",
        maxByteSize: 10 * MINDSET_MEBIBYTE,
        allowedContentTypes: Object.freeze([
            "image/jpeg",
            "image/png",
            "image/webp",
            "image/heic",
            "image/heif",
        ]),
    }),
    VIDEO: Object.freeze({
        kind: "VIDEO",
        maxByteSize: 80 * MINDSET_MEBIBYTE,
        allowedContentTypes: Object.freeze([
            "video/mp4",
            "video/quicktime",
            "video/webm",
            "video/x-m4v",
        ]),
    }),
    AUDIO: Object.freeze({
        kind: "AUDIO",
        maxByteSize: 16 * MINDSET_MEBIBYTE,
        allowedContentTypes: Object.freeze([
            "audio/aac",
            "audio/m4a",
            "audio/mp4",
            "audio/mpeg",
            "audio/webm",
            "audio/wav",
        ]),
    }),
    FILE: Object.freeze({
        kind: "FILE",
        maxByteSize: 25 * MINDSET_MEBIBYTE,
        allowedContentTypes: Object.freeze([
            "application/pdf",
            "text/plain",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        ]),
    }),
});
const MINDSET_MESSAGE_ATTACHMENT_EXECUTION_BLOCKED_GATES = Object.freeze([
    "OBJECT_STORAGE_PROVIDER",
    "SIGNED_UPLOAD_URLS",
    "SCANNER_WORKER",
    "CLEAN_ATTACHMENT_COMMIT",
    "THUMBNAIL_WORKER",
    "OBJECT_CLEANUP_WORKER",
    "MEDIA_DELIVERY_PRIVACY",
    "DEVICE_ACCEPTANCE_EVIDENCE",
]);
const CALL_KINDS = new Set(["AUDIO", "VIDEO"]);
const CALL_STATUSES = new Set([
    "RINGING",
    "ACCEPTED",
    "DECLINED",
    "CANCELLED",
    "MISSED",
    "ENDED",
]);
const MESSAGE_TYPES = new Set([
    "TEXT",
    "EXTERNAL_CONTENT_REPLY",
    "ATTACHMENT",
    "SYSTEM",
]);
const EXTERNAL_CONTENT_KINDS = new Set([
    "FLEX",
    "SHORT_VIDEO",
    "PHOTO",
    "POST",
]);
const MESSAGE_STATUSES = new Set(["SENT", "DELETED"]);
const MESSAGE_DELETE_REASONS = new Set([
    "RETRACT",
    "DELETE",
]);
const MESSAGE_ATTACHMENT_KINDS = new Set([
    "IMAGE",
    "VIDEO",
    "AUDIO",
    "FILE",
]);
const MESSAGE_RECEIPT_STATUSES = new Set([
    "DELIVERED",
    "READ",
]);
const MESSAGE_REPORT_REASONS = new Set([
    "SPAM",
    "HARASSMENT",
    "IMPERSONATION",
    "ILLEGAL_CONTENT",
    "OTHER",
]);
const MESSAGE_REPORT_STATUSES = new Set([
    "OPEN",
    "REVIEWED",
    "DISMISSED",
    "ACTIONED",
]);
const CONTACT_DISCOVERY_MODES = new Set([
    "OFF",
    "CONTACTS",
]);
const PROFILE_VISIBILITIES = new Set([
    "TENANT",
    "CONTACTS",
    "PRIVATE",
]);
const COMMUNICATION_CONSENT_POLICIES = new Set([
    "ASK_EVERY_TIME",
    "ALWAYS_ALLOW",
]);
const CONTACT_HANDLE_KINDS = new Set([
    "PHONE_SHA256",
    "EMAIL_SHA256",
]);
const CONTACT_HANDLE_HASH = /^[a-f0-9]{64}$/u;
const CONTACT_HANDLE_E164_PHONE = /^\+[1-9][0-9]{7,14}$/u;
const CONTACT_HANDLE_NANP_REGIONS = new Set(["US", "CA"]);
const CONTACT_HANDLE_DEFAULT_REGION_PHONE_METADATA = new Map([
    [
        "GB",
        {
            callingCode: "44",
            nationalPrefix: "0",
            minNationalLength: 9,
            maxNationalLength: 10,
        },
    ],
    [
        "AU",
        {
            callingCode: "61",
            nationalPrefix: "0",
            minNationalLength: 9,
            maxNationalLength: 9,
        },
    ],
    [
        "NZ",
        {
            callingCode: "64",
            nationalPrefix: "0",
            minNationalLength: 8,
            maxNationalLength: 9,
        },
    ],
    [
        "IE",
        {
            callingCode: "353",
            nationalPrefix: "0",
            minNationalLength: 7,
            maxNationalLength: 9,
        },
    ],
]);
const MESSAGE_EVENT_TYPES = new Set([
    "MESSAGE_SENT",
    "MESSAGE_EDITED",
    "MESSAGE_DELETED",
]);
const MESSAGE_RECEIPT_EVENT_TYPES = new Set([
    "MESSAGE_RECEIPT_UPDATED",
]);
const MESSAGE_STATUS_BY_EVENT_TYPE = {
    MESSAGE_SENT: "SENT",
    MESSAGE_EDITED: "SENT",
    MESSAGE_DELETED: "DELETED",
};
const CONVERSATION_PRESENCE_EVENT_TYPES = new Set([
    "CONVERSATION_TYPING_STARTED",
    "CONVERSATION_TYPING_STOPPED",
]);
const CONVERSATION_KINDS = new Set([
    "DIRECT",
    "GROUP",
]);
const CONVERSATION_PARTICIPANT_ROLES = new Set(["OWNER", "ADMIN", "MEMBER"]);
const CONVERSATION_PARTICIPANT_STATUSES = new Set([
    "ACTIVE",
    "LEFT",
    "REMOVED",
]);
const CALL_EVENT_TYPES = new Set([
    "CALL_STARTED",
    "CALL_ACCEPTED",
    "CALL_DECLINED",
    "CALL_CANCELLED",
    "CALL_MISSED",
    "CALL_ENDED",
    "CALL_ESCALATION_REQUESTED",
    "CALL_ESCALATION_ACCEPTED",
    "CALL_ESCALATION_DECLINED",
]);
const GROUP_CALL_INVITE_PARTICIPANT_STATUSES = new Set([
    "READY",
    "SELF",
    "DUPLICATE",
    "NOT_IN_CONVERSATION",
    "BLOCKED",
    "QUOTA_EXCEEDED",
    "CAPABILITY_DISABLED",
]);
function isMindsetCallEscalation(value) {
    return (isRecord(value) &&
        isNonEmptyString(value.requestedBy) &&
        isTimestamp(value.requestedAt) &&
        isTimestamp(value.expiresAt));
}
/** Runtime guard for data received from API, push, or realtime boundaries. */
function isMindsetCallSession(value) {
    if (!isRecord(value) || !isRecord(value.caller) || !isRecord(value.recipient)) {
        return false;
    }
    return (isNonEmptyString(value.id) &&
        isNonEmptyString(value.tenantId) &&
        isNonEmptyString(value.conversationId) &&
        isNonEmptyString(value.roomName) &&
        isMindsetCallParticipant(value.caller) &&
        isMindsetCallParticipant(value.recipient) &&
        value.caller.userId !== value.recipient.userId &&
        CALL_KINDS.has(value.kind) &&
        CALL_STATUSES.has(value.status) &&
        isTimestamp(value.createdAt) &&
        isTimestamp(value.expiresAt) &&
        isNullableTimestamp(value.acceptedAt) &&
        isNullableTimestamp(value.endedAt) &&
        (value.escalation === undefined ||
            value.escalation === null ||
            isMindsetCallEscalation(value.escalation)));
}
function isMindsetGroupCallInvitePlan(value) {
    if (!isRecord(value) || !Array.isArray(value.participants))
        return false;
    return (value.version === exports.MINDSET_GROUP_CALL_INVITE_PLAN_VERSION &&
        isNonEmptyString(value.tenantId) &&
        isNonEmptyString(value.conversationId) &&
        isNonEmptyString(value.actorUserId) &&
        CALL_KINDS.has(value.kind) &&
        (value.verdict === "READY" || value.verdict === "BLOCKED") &&
        typeof value.maxInvitees === "number" &&
        Number.isInteger(value.maxInvitees) &&
        value.maxInvitees >= 1 &&
        value.maxInvitees <= 16 &&
        typeof value.readyInviteeCount === "number" &&
        Number.isInteger(value.readyInviteeCount) &&
        value.readyInviteeCount >= 0 &&
        value.readyInviteeCount <= 16 &&
        value.participants.length >= 1 &&
        value.participants.length <= 24 &&
        value.participants.every(isMindsetGroupCallInvitePlanParticipant) &&
        Array.isArray(value.blockedReasons) &&
        value.blockedReasons.every(isNonEmptyString) &&
        value.routeFamily === "mindset/v1/group-calls" &&
        value.routeEnabled === false &&
        value.liveKitRoomCreated === false &&
        value.pushFanoutEnabled === false &&
        value.termsV1CallSurfaceChanged === false);
}
/** Runtime guard for untrusted realtime event payloads. */
function isMindsetCallEvent(value) {
    if (!isRecord(value) || !isMindsetCallSession(value.call))
        return false;
    return (isNonEmptyString(value.id) &&
        CALL_EVENT_TYPES.has(value.type) &&
        isNonEmptyString(value.tenantId) &&
        isNonEmptyString(value.callId) &&
        isTimestamp(value.occurredAt) &&
        (value.actorUserId === null || isNonEmptyString(value.actorUserId)) &&
        value.call.id === value.callId &&
        value.call.tenantId === value.tenantId);
}
/** Runtime guard for conversation data received from API or realtime boundaries. */
function isMindsetConversation(value) {
    if (!isRecord(value) || !Array.isArray(value.participants))
        return false;
    return (isNonEmptyString(value.id) &&
        isNonEmptyString(value.tenantId) &&
        CONVERSATION_KINDS.has(value.kind) &&
        (value.title === null || typeof value.title === "string") &&
        value.participants.length > 0 &&
        value.participants.every(isMindsetConversationParticipant) &&
        isTimestamp(value.lastActivityAt) &&
        isTimestamp(value.createdAt) &&
        isNullableTimestamp(value.archivedAt) &&
        (value.summary === undefined ||
            isMindsetConversationSummary(value.summary, value)));
}
/** Runtime guard for message data received from API or realtime boundaries. */
function isMindsetMessage(value) {
    if (!isRecord(value))
        return false;
    const type = value.type;
    const externalContent = value.externalContent;
    return (isNonEmptyString(value.id) &&
        isNonEmptyString(value.tenantId) &&
        isNonEmptyString(value.conversationId) &&
        isNonEmptyString(value.senderId) &&
        isNonEmptyString(value.clientMessageId) &&
        MESSAGE_TYPES.has(type) &&
        typeof value.body === "string" &&
        (type === "EXTERNAL_CONTENT_REPLY"
            ? isMindsetExternalContentReference(externalContent)
            : externalContent === null || externalContent === undefined) &&
        (value.replyTo === undefined ||
            value.replyTo === null ||
            isMindsetMessageReplyContext(value.replyTo)) &&
        MESSAGE_STATUSES.has(value.status) &&
        isTimestamp(value.createdAt) &&
        isNullableTimestamp(value.editedAt) &&
        isNullableTimestamp(value.deletedAt) &&
        (value.deleteReason === undefined ||
            value.deleteReason === null ||
            MESSAGE_DELETE_REASONS.has(value.deleteReason)) &&
        (value.expiresAt === undefined || isNullableTimestamp(value.expiresAt)) &&
        (value.expiredAt === undefined || isNullableTimestamp(value.expiredAt)));
}
/** Runtime guard for the denormalized reply-target context on a message. */
function isMindsetMessageReplyContext(value) {
    if (!isRecord(value))
        return false;
    return (isNonEmptyString(value.messageId) &&
        isNonEmptyString(value.senderId) &&
        MESSAGE_TYPES.has(value.kind) &&
        typeof value.bodyPreview === "string" &&
        value.bodyPreview.length <= 120 &&
        (value.attachmentKind === null ||
            MESSAGE_ATTACHMENT_KINDS.has(value.attachmentKind)) &&
        typeof value.deleted === "boolean" &&
        (value.expiresAt === undefined || isNullableTimestamp(value.expiresAt)));
}
/** Runtime guard for a non-media reference owned by an external product. */
function isMindsetExternalContentReference(value) {
    if (!isRecord(value))
        return false;
    return (typeof value.provider === "string" &&
        /^[a-z0-9][a-z0-9._-]{1,63}$/u.test(value.provider) &&
        EXTERNAL_CONTENT_KINDS.has(value.kind) &&
        isNonEmptyString(value.externalId) &&
        value.externalId.length <= 255 &&
        isNonEmptyString(value.version) &&
        value.version.length <= 32 &&
        isNonEmptyString(value.label) &&
        value.label.length <= 120 &&
        (value.openPath === null ||
            (typeof value.openPath === "string" &&
                value.openPath.startsWith("/") &&
                value.openPath.length <= 512)) &&
        (value.ownerUserId === null ||
            (isNonEmptyString(value.ownerUserId) && value.ownerUserId.length <= 255)));
}
/** Runtime guard for a user-owned mailbox folder. */
function isMindsetMessageFolder(value) {
    if (!isRecord(value))
        return false;
    return (isNonEmptyString(value.id) &&
        isNonEmptyString(value.tenantId) &&
        isNonEmptyString(value.userId) &&
        isNonEmptyString(value.name) &&
        value.name.length <= 40 &&
        typeof value.conversationCount === "number" &&
        Number.isSafeInteger(value.conversationCount) &&
        value.conversationCount >= 0 &&
        isTimestamp(value.createdAt) &&
        isTimestamp(value.updatedAt));
}
function isMindsetConversationSummary(value, conversation) {
    if (!isRecord(value))
        return false;
    const lastMessage = value.lastMessage;
    return (isNonEmptyString(value.userId) &&
        typeof value.unreadMessageCount === "number" &&
        Number.isSafeInteger(value.unreadMessageCount) &&
        value.unreadMessageCount >= 0 &&
        (lastMessage === null ||
            (isMindsetMessage(lastMessage) &&
                lastMessage.tenantId === conversation.tenantId &&
                lastMessage.conversationId === conversation.id)));
}
/** Runtime guard for clean attachment metadata received from API boundaries. */
function isMindsetMessageAttachment(value) {
    if (!isRecord(value))
        return false;
    return (isNonEmptyString(value.id) &&
        isNonEmptyString(value.tenantId) &&
        isNonEmptyString(value.conversationId) &&
        isNonEmptyString(value.messageId) &&
        isNonEmptyString(value.ownerUserId) &&
        MESSAGE_ATTACHMENT_KINDS.has(value.kind) &&
        isNonEmptyString(value.contentType) &&
        typeof value.byteSize === "number" &&
        Number.isSafeInteger(value.byteSize) &&
        value.byteSize >= 0 &&
        typeof value.sha256 === "string" &&
        /^[a-f0-9]{64}$/u.test(value.sha256) &&
        value.scannerStatus === "CLEAN" &&
        isTimestamp(value.createdAt) &&
        (value.durationMs === undefined ||
            (typeof value.durationMs === "number" &&
                Number.isSafeInteger(value.durationMs) &&
                value.durationMs > 0)) &&
        (value.waveform === undefined ||
            (Array.isArray(value.waveform) &&
                value.waveform.length <= 100 &&
                value.waveform.every((sample) => typeof sample === "number" &&
                    Number.isSafeInteger(sample) &&
                    sample >= 0 &&
                    sample <= 255))) &&
        !("objectKey" in value) &&
        !("thumbnailObjectKey" in value) &&
        !("signedUrl" in value) &&
        !("downloadUrl" in value));
}
function buildMindsetMessageAttachmentUploadReadiness(input) {
    const blockedGates = input.messagingEnabled
        ? [...MINDSET_MESSAGE_ATTACHMENT_EXECUTION_BLOCKED_GATES]
        : ["MESSAGING_CAPABILITY", ...MINDSET_MESSAGE_ATTACHMENT_EXECUTION_BLOCKED_GATES];
    return {
        version: exports.MINDSET_MESSAGE_ATTACHMENT_UPLOAD_READINESS_VERSION,
        tenantId: input.tenantId,
        conversationId: input.conversationId,
        routeFamily: "mindset/v1/message-attachments",
        uploadIntentRoute: "POST /mindset/v1/tenants/:tenantId/conversations/:conversationId/attachments/uploads",
        readinessStatus: "DISABLED",
        messagingCapabilityEnabled: input.messagingEnabled,
        uploadIntentsEnabled: false,
        mediaMessageSendsEnabled: false,
        cleanAttachmentCommitRequired: true,
        scannerRequired: true,
        storageLocatorsExposed: false,
        signedUrlsPersistable: false,
        termsCompatibilityProtected: input.termsCompatibilityProtected ?? input.tenantId === exports.TERMS_TENANT_ID,
        acceptedPolicies: [
            exports.MINDSET_MESSAGE_ATTACHMENT_POLICIES.IMAGE,
            exports.MINDSET_MESSAGE_ATTACHMENT_POLICIES.FILE,
        ],
        blockedGates,
    };
}
function isMindsetMessageAttachmentUploadReadiness(value) {
    if (!isRecord(value))
        return false;
    return (value.version === exports.MINDSET_MESSAGE_ATTACHMENT_UPLOAD_READINESS_VERSION &&
        isNonEmptyString(value.tenantId) &&
        isNonEmptyString(value.conversationId) &&
        value.routeFamily === "mindset/v1/message-attachments" &&
        value.uploadIntentRoute ===
            "POST /mindset/v1/tenants/:tenantId/conversations/:conversationId/attachments/uploads" &&
        value.readinessStatus === "DISABLED" &&
        typeof value.messagingCapabilityEnabled === "boolean" &&
        value.uploadIntentsEnabled === false &&
        value.mediaMessageSendsEnabled === false &&
        value.cleanAttachmentCommitRequired === true &&
        value.scannerRequired === true &&
        value.storageLocatorsExposed === false &&
        value.signedUrlsPersistable === false &&
        typeof value.termsCompatibilityProtected === "boolean" &&
        Array.isArray(value.acceptedPolicies) &&
        value.acceptedPolicies.length === 2 &&
        value.acceptedPolicies.every(isMindsetMessageAttachmentPolicy) &&
        Array.isArray(value.blockedGates) &&
        value.blockedGates.length >= 1 &&
        value.blockedGates.every(isMessageAttachmentUploadBlockedGate) &&
        !("objectKey" in value) &&
        !("thumbnailObjectKey" in value) &&
        !("storageProvider" in value) &&
        !("signedUrl" in value) &&
        !("downloadUrl" in value) &&
        !("uploadUrl" in value));
}
function getMindsetMessageAttachmentPolicy(kind) {
    return MESSAGE_ATTACHMENT_KINDS.has(kind)
        ? exports.MINDSET_MESSAGE_ATTACHMENT_POLICIES[kind]
        : null;
}
function normalizeMindsetMessageAttachmentContentType(contentType) {
    const normalized = contentType.split(";")[0]?.trim().toLowerCase() ?? "";
    return /^[a-z0-9][a-z0-9!#$&^_.+-]*\/[a-z0-9][a-z0-9!#$&^_.+-]*$/u.test(normalized)
        ? normalized
        : null;
}
function evaluateMindsetMessageAttachmentPolicy(input) {
    const policy = getMindsetMessageAttachmentPolicy(input.kind);
    if (!policy) {
        return { accepted: false, reason: "UNSUPPORTED_KIND" };
    }
    const normalizedContentType = normalizeMindsetMessageAttachmentContentType(input.contentType);
    if (!normalizedContentType ||
        !policy.allowedContentTypes.includes(normalizedContentType)) {
        return {
            accepted: false,
            reason: "UNSUPPORTED_CONTENT_TYPE",
            kind: policy.kind,
            ...(normalizedContentType ? { normalizedContentType } : {}),
            maxByteSize: policy.maxByteSize,
        };
    }
    if (!Number.isSafeInteger(input.byteSize) || input.byteSize < 1) {
        return {
            accepted: false,
            reason: "INVALID_BYTE_SIZE",
            kind: policy.kind,
            normalizedContentType,
            maxByteSize: policy.maxByteSize,
        };
    }
    if (input.byteSize > policy.maxByteSize) {
        return {
            accepted: false,
            reason: "BYTE_SIZE_EXCEEDED",
            kind: policy.kind,
            normalizedContentType,
            maxByteSize: policy.maxByteSize,
        };
    }
    return {
        accepted: true,
        kind: policy.kind,
        normalizedContentType,
        maxByteSize: policy.maxByteSize,
    };
}
function deriveMindsetMessageAttachmentPresentationState(input) {
    if (input.status === "ACCEPTED") {
        if (!isMindsetMessageAttachment(input.attachment)) {
            throw new Error("Accepted attachment presentation requires clean metadata");
        }
        return {
            version: exports.MINDSET_MESSAGE_ATTACHMENT_PRESENTATION_VERSION,
            status: "READY",
            kind: input.attachment.kind,
            attachment: input.attachment,
            reason: null,
            deletedAt: null,
            clientMessageId: null,
            showPreview: true,
            showRetry: false,
            showBlockedReason: false,
            cacheAllowed: true,
        };
    }
    if (!MESSAGE_ATTACHMENT_KINDS.has(input.kind)) {
        throw new Error("Attachment presentation kind must be IMAGE or FILE");
    }
    if (input.status === "BLOCKED") {
        return {
            version: exports.MINDSET_MESSAGE_ATTACHMENT_PRESENTATION_VERSION,
            status: "BLOCKED",
            kind: input.kind,
            attachment: null,
            reason: normalizeAttachmentClientReason(input.reason, "Attachment presentation reason"),
            deletedAt: null,
            clientMessageId: null,
            showPreview: false,
            showRetry: false,
            showBlockedReason: true,
            cacheAllowed: false,
        };
    }
    if (input.status === "DELETED") {
        if (!isTimestamp(input.deletedAt)) {
            throw new Error("Deleted attachment presentation requires deletedAt");
        }
        return {
            version: exports.MINDSET_MESSAGE_ATTACHMENT_PRESENTATION_VERSION,
            status: "DELETED",
            kind: input.kind,
            attachment: null,
            reason: null,
            deletedAt: input.deletedAt,
            clientMessageId: null,
            showPreview: false,
            showRetry: false,
            showBlockedReason: false,
            cacheAllowed: false,
        };
    }
    if (input.status === "RETRY") {
        if (!isNonEmptyString(input.clientMessageId)) {
            throw new Error("Retry attachment presentation requires clientMessageId");
        }
        return {
            version: exports.MINDSET_MESSAGE_ATTACHMENT_PRESENTATION_VERSION,
            status: "RETRYABLE",
            kind: input.kind,
            attachment: null,
            reason: normalizeAttachmentClientReason(input.reason, "Attachment presentation reason"),
            deletedAt: null,
            clientMessageId: input.clientMessageId,
            showPreview: false,
            showRetry: true,
            showBlockedReason: false,
            cacheAllowed: false,
        };
    }
    throw new Error("Unsupported attachment presentation status");
}
function deriveMindsetMessageAttachmentTransferState(input) {
    assertAttachmentTransferUserSelection(input.selectedByUser, input.permissionRequested);
    if (input.status === "CACHED") {
        if (!isMindsetMessageAttachment(input.attachment)) {
            throw new Error("Cached attachment transfer requires clean metadata");
        }
        if (!isTimestamp(input.cachedAt) || !isTimestamp(input.expiresAt)) {
            throw new Error("Cached attachment transfer requires cache timestamps");
        }
        if (Date.parse(input.expiresAt) <= Date.parse(input.cachedAt)) {
            throw new Error("Cached attachment transfer expiresAt must follow cachedAt");
        }
        if (input.clientMessageId !== undefined &&
            !isNonEmptyString(input.clientMessageId)) {
            throw new Error("Attachment transfer clientMessageId is required when set");
        }
        return {
            version: exports.MINDSET_MESSAGE_ATTACHMENT_TRANSFER_VERSION,
            status: "CACHED",
            kind: input.attachment.kind,
            clientMessageId: input.clientMessageId ?? null,
            attachment: input.attachment,
            byteSize: input.attachment.byteSize,
            uploadedByteSize: input.attachment.byteSize,
            progressRatio: 1,
            reason: null,
            cancelledAt: null,
            cachedAt: input.cachedAt,
            cacheExpiresAt: input.expiresAt,
            selectedByUser: true,
            permissionRequested: false,
            showCancel: false,
            showRetry: false,
            cacheAllowed: true,
        };
    }
    assertAttachmentTransferKind(input.kind);
    assertAttachmentTransferClientMessageId(input.clientMessageId);
    if (input.status === "QUEUED") {
        return {
            version: exports.MINDSET_MESSAGE_ATTACHMENT_TRANSFER_VERSION,
            status: "QUEUED",
            kind: input.kind,
            clientMessageId: input.clientMessageId,
            attachment: null,
            byteSize: null,
            uploadedByteSize: null,
            progressRatio: 0,
            reason: null,
            cancelledAt: null,
            cachedAt: null,
            cacheExpiresAt: null,
            selectedByUser: true,
            permissionRequested: false,
            showCancel: true,
            showRetry: false,
            cacheAllowed: false,
        };
    }
    if (input.status === "UPLOADING") {
        assertAttachmentTransferProgress(input.byteSize, input.uploadedByteSize);
        return {
            version: exports.MINDSET_MESSAGE_ATTACHMENT_TRANSFER_VERSION,
            status: "UPLOADING",
            kind: input.kind,
            clientMessageId: input.clientMessageId,
            attachment: null,
            byteSize: input.byteSize,
            uploadedByteSize: input.uploadedByteSize,
            progressRatio: input.uploadedByteSize / input.byteSize,
            reason: null,
            cancelledAt: null,
            cachedAt: null,
            cacheExpiresAt: null,
            selectedByUser: true,
            permissionRequested: false,
            showCancel: true,
            showRetry: false,
            cacheAllowed: false,
        };
    }
    if (input.status === "CANCELLED") {
        if (!isTimestamp(input.cancelledAt)) {
            throw new Error("Cancelled attachment transfer requires cancelledAt");
        }
        return {
            version: exports.MINDSET_MESSAGE_ATTACHMENT_TRANSFER_VERSION,
            status: "CANCELLED",
            kind: input.kind,
            clientMessageId: input.clientMessageId,
            attachment: null,
            byteSize: null,
            uploadedByteSize: null,
            progressRatio: null,
            reason: null,
            cancelledAt: input.cancelledAt,
            cachedAt: null,
            cacheExpiresAt: null,
            selectedByUser: true,
            permissionRequested: false,
            showCancel: false,
            showRetry: true,
            cacheAllowed: false,
        };
    }
    if (input.status === "FAILED") {
        return {
            version: exports.MINDSET_MESSAGE_ATTACHMENT_TRANSFER_VERSION,
            status: "FAILED",
            kind: input.kind,
            clientMessageId: input.clientMessageId,
            attachment: null,
            byteSize: null,
            uploadedByteSize: null,
            progressRatio: null,
            reason: normalizeAttachmentClientReason(input.reason, "Attachment transfer reason"),
            cancelledAt: null,
            cachedAt: null,
            cacheExpiresAt: null,
            selectedByUser: true,
            permissionRequested: false,
            showCancel: false,
            showRetry: true,
            cacheAllowed: false,
        };
    }
    throw new Error("Unsupported attachment transfer status");
}
function deriveMindsetMessageAttachmentAccessibilityState(input) {
    if (input.surface === "PRESENTATION") {
        return derivePresentationAttachmentAccessibilityState(input.state);
    }
    if (input.surface === "TRANSFER") {
        return deriveTransferAttachmentAccessibilityState(input.state);
    }
    throw new Error("Unsupported attachment accessibility surface");
}
/** Runtime guard for message delivery/read receipt data received from API boundaries. */
function isMindsetMessageReceipt(value) {
    if (!isRecord(value))
        return false;
    return (isNonEmptyString(value.tenantId) &&
        isNonEmptyString(value.conversationId) &&
        isNonEmptyString(value.messageId) &&
        isNonEmptyString(value.userId) &&
        MESSAGE_RECEIPT_STATUSES.has(value.status) &&
        isTimestamp(value.deliveredAt) &&
        isNullableTimestamp(value.readAt) &&
        (value.listenedAt === undefined || isNullableTimestamp(value.listenedAt)) &&
        (value.listenedAt == null || value.status === "READ") &&
        (value.listenedAtRedacted === undefined || typeof value.listenedAtRedacted === "boolean") &&
        (value.listenedAtRedacted !== true || value.listenedAt === null) &&
        isTimestamp(value.updatedAt) &&
        ((value.status === "DELIVERED" && value.readAt === null) ||
            (value.status === "READ" && isTimestamp(value.readAt))));
}
/** Runtime guard for message reaction data received from API boundaries. */
function isMindsetMessageReaction(value) {
    if (!isRecord(value))
        return false;
    return (isNonEmptyString(value.tenantId) &&
        isNonEmptyString(value.conversationId) &&
        isNonEmptyString(value.messageId) &&
        isNonEmptyString(value.userId) &&
        isNonEmptyString(value.emoji) &&
        value.emoji.length <= 32 &&
        isTimestamp(value.updatedAt));
}
/** Runtime guard for message report data received from API boundaries. */
function isMindsetMessageReport(value) {
    if (!isRecord(value))
        return false;
    return (isNonEmptyString(value.id) &&
        isNonEmptyString(value.tenantId) &&
        isNonEmptyString(value.conversationId) &&
        isNonEmptyString(value.messageId) &&
        isNonEmptyString(value.reporterUserId) &&
        isNonEmptyString(value.reportedUserId) &&
        value.reporterUserId !== value.reportedUserId &&
        MESSAGE_REPORT_REASONS.has(value.reason) &&
        (value.note === null ||
            (typeof value.note === "string" && value.note.length <= 1000)) &&
        MESSAGE_REPORT_STATUSES.has(value.status) &&
        isTimestamp(value.createdAt) &&
        isTimestamp(value.updatedAt));
}
/** Runtime guard for contact discovery safety report data. */
function isMindsetContactDiscoveryReport(value) {
    if (!isRecord(value))
        return false;
    return (isNonEmptyString(value.id) &&
        isNonEmptyString(value.tenantId) &&
        isNonEmptyString(value.reporterUserId) &&
        isNonEmptyString(value.reportedUserId) &&
        value.reporterUserId !== value.reportedUserId &&
        MESSAGE_REPORT_REASONS.has(value.reason) &&
        (value.note === null ||
            (typeof value.note === "string" && value.note.length <= 1000)) &&
        MESSAGE_REPORT_STATUSES.has(value.status) &&
        isTimestamp(value.createdAt) &&
        isTimestamp(value.updatedAt));
}
/** Runtime guard for first-party profile data received from API boundaries. */
function isMindsetUserProfile(value) {
    if (!isRecord(value))
        return false;
    return (isNonEmptyString(value.tenantId) &&
        isNonEmptyString(value.userId) &&
        isNonEmptyString(value.displayName) &&
        (value.avatarUrl === null || typeof value.avatarUrl === "string") &&
        isTimestamp(value.updatedAt));
}
/** Runtime guard for first-party contact discovery settings. */
function isMindsetContactDiscoverySettings(value) {
    if (!isRecord(value) || !Array.isArray(value.handles))
        return false;
    return (isNonEmptyString(value.tenantId) &&
        isNonEmptyString(value.userId) &&
        CONTACT_DISCOVERY_MODES.has(value.mode) &&
        value.handles.every(isMindsetContactHandle) &&
        isTimestamp(value.updatedAt));
}
/** Runtime guard for first-party account privacy and messaging settings. */
function isMindsetAccountSettings(value) {
    if (!isRecord(value) || !Array.isArray(value.blockedUserIds))
        return false;
    const videoAllowed = value.videoAlwaysAllowedUserIds;
    return (isNonEmptyString(value.tenantId) &&
        isNonEmptyString(value.userId) &&
        PROFILE_VISIBILITIES.has(value.profileVisibility) &&
        typeof value.readReceiptsEnabled === "boolean" &&
        typeof value.messagePreviewEnabled === "boolean" &&
        value.blockedUserIds.every(isNonEmptyString) &&
        new Set(value.blockedUserIds).size === value.blockedUserIds.length &&
        !value.blockedUserIds.includes(value.userId) &&
        (value.videoRequestPolicy === undefined ||
            COMMUNICATION_CONSENT_POLICIES.has(value.videoRequestPolicy)) &&
        (videoAllowed === undefined ||
            (Array.isArray(videoAllowed) &&
                videoAllowed.every(isNonEmptyString) &&
                new Set(videoAllowed).size === videoAllowed.length &&
                !videoAllowed.includes(value.userId))) &&
        isTimestamp(value.updatedAt));
}
/** Runtime guard for per-user conversation notification settings. */
function isMindsetConversationNotificationSettings(value) {
    if (!isRecord(value))
        return false;
    return (isNonEmptyString(value.tenantId) &&
        isNonEmptyString(value.conversationId) &&
        isNonEmptyString(value.userId) &&
        (value.mutedUntil === null || isTimestamp(value.mutedUntil)) &&
        isTimestamp(value.updatedAt));
}
/** Runtime guard for a contact match returned by exact hash lookup. */
function isMindsetContactMatch(value) {
    if (!isRecord(value))
        return false;
    return (isNonEmptyString(value.tenantId) &&
        isNonEmptyString(value.userId) &&
        isNonEmptyString(value.displayName) &&
        (value.avatarUrl === null || typeof value.avatarUrl === "string") &&
        isMindsetContactHandle(value.handle));
}
/** Runtime guard for message events received from realtime boundaries. */
function isMindsetMessageEvent(value) {
    if (!isRecord(value) ||
        !isMindsetConversation(value.conversation) ||
        !isMindsetMessage(value.message)) {
        return false;
    }
    return (isNonEmptyString(value.id) &&
        MESSAGE_EVENT_TYPES.has(value.type) &&
        isNonEmptyString(value.tenantId) &&
        isNonEmptyString(value.conversationId) &&
        isNonEmptyString(value.messageId) &&
        isTimestamp(value.occurredAt) &&
        isNonEmptyString(value.actorUserId) &&
        value.conversation.tenantId === value.tenantId &&
        value.conversation.id === value.conversationId &&
        value.message.tenantId === value.tenantId &&
        value.message.conversationId === value.conversationId &&
        value.message.id === value.messageId &&
        value.message.senderId === value.actorUserId &&
        value.message.status ===
            MESSAGE_STATUS_BY_EVENT_TYPE[value.type]);
}
/** Runtime guard for read/delivery receipt events received from realtime boundaries. */
function isMindsetMessageReceiptEvent(value) {
    if (!isRecord(value) ||
        !isMindsetConversation(value.conversation) ||
        !isMindsetMessageReceipt(value.receipt)) {
        return false;
    }
    return (isNonEmptyString(value.id) &&
        MESSAGE_RECEIPT_EVENT_TYPES.has(value.type) &&
        isNonEmptyString(value.tenantId) &&
        isNonEmptyString(value.conversationId) &&
        isNonEmptyString(value.messageId) &&
        isTimestamp(value.occurredAt) &&
        isNonEmptyString(value.actorUserId) &&
        value.conversation.tenantId === value.tenantId &&
        value.conversation.id === value.conversationId &&
        value.receipt.tenantId === value.tenantId &&
        value.receipt.conversationId === value.conversationId &&
        value.receipt.messageId === value.messageId &&
        value.receipt.userId === value.actorUserId &&
        value.conversation.participants.some((participant) => participant.userId === value.actorUserId &&
            participant.status === "ACTIVE"));
}
/** Runtime guard for ephemeral conversation-presence realtime events. */
function isMindsetConversationPresenceEvent(value) {
    if (!isRecord(value) || !isMindsetConversation(value.conversation)) {
        return false;
    }
    const occurredAtMs = typeof value.occurredAt === "string" ? Date.parse(value.occurredAt) : NaN;
    const expiresAtMs = typeof value.expiresAt === "string" ? Date.parse(value.expiresAt) : NaN;
    return (isNonEmptyString(value.id) &&
        CONVERSATION_PRESENCE_EVENT_TYPES.has(value.type) &&
        isNonEmptyString(value.tenantId) &&
        isNonEmptyString(value.conversationId) &&
        isTimestamp(value.occurredAt) &&
        isNonEmptyString(value.actorUserId) &&
        (value.leaseId === undefined || isNonEmptyString(value.leaseId)) &&
        isTimestamp(value.expiresAt) &&
        Number.isFinite(occurredAtMs) &&
        Number.isFinite(expiresAtMs) &&
        expiresAtMs >= occurredAtMs &&
        value.conversation.tenantId === value.tenantId &&
        value.conversation.id === value.conversationId &&
        value.conversation.participants.some((participant) => participant.userId === value.actorUserId &&
            participant.status === "ACTIVE"));
}
/** Runtime guard for any event delivered over the Mindset realtime channel. */
function isMindsetRealtimeEvent(value) {
    return (isMindsetCallEvent(value) ||
        isMindsetMessageEvent(value) ||
        isMindsetMessageReceiptEvent(value) ||
        isMindsetConversationPresenceEvent(value));
}
function isMindsetConversationParticipant(value) {
    if (!isRecord(value))
        return false;
    return (isNonEmptyString(value.userId) &&
        isNonEmptyString(value.displayName) &&
        (value.avatarUrl === null || typeof value.avatarUrl === "string") &&
        CONVERSATION_PARTICIPANT_ROLES.has(value.role) &&
        CONVERSATION_PARTICIPANT_STATUSES.has(value.status) &&
        isTimestamp(value.joinedAt) &&
        isNullableTimestamp(value.leftAt));
}
/**
 * Creates a URL/header-safe key suitable for retrying one logical call start.
 * Persist and reuse the returned key when an application retries that action.
 */
function createMindsetIdempotencyKey(prefix = "call") {
    const normalizedPrefix = prefix.trim();
    if (!/^[A-Za-z0-9._:-]{1,40}$/.test(normalizedPrefix)) {
        throw new TypeError("idempotency key prefix must contain 1 to 40 URL-safe characters");
    }
    const randomUuid = globalThis.crypto?.randomUUID?.();
    const uniquePart = randomUuid ??
        `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
    return `${normalizedPrefix}-${uniquePart}`;
}
function isMindsetCallParticipant(value) {
    return (isNonEmptyString(value.userId) &&
        isNonEmptyString(value.displayName) &&
        (value.avatarUrl === null || typeof value.avatarUrl === "string"));
}
function isMindsetGroupCallInvitePlanParticipant(value) {
    if (!isRecord(value))
        return false;
    return (isNonEmptyString(value.userId) &&
        isNonEmptyString(value.displayName) &&
        (value.avatarUrl === null || typeof value.avatarUrl === "string") &&
        GROUP_CALL_INVITE_PARTICIPANT_STATUSES.has(value.status) &&
        (value.reason === null || isNonEmptyString(value.reason)));
}
function normalizeMindsetContactHandleValue(rawValue, options = {}) {
    if (typeof rawValue !== "string") {
        throw new TypeError("Contact handle must be a string");
    }
    const trimmed = rawValue.trim();
    if (!trimmed) {
        throw new TypeError("Contact handle is required");
    }
    if (trimmed.includes("@")) {
        return {
            kind: "EMAIL_SHA256",
            normalizedValue: trimmed.toLowerCase(),
        };
    }
    return {
        kind: "PHONE_SHA256",
        normalizedValue: normalizeMindsetContactPhone(trimmed, options.defaultRegion),
    };
}
function createMindsetContactHandle(rawValue, options) {
    if (typeof options?.sha256Hex !== "function") {
        throw new TypeError("sha256Hex function is required");
    }
    const normalized = normalizeMindsetContactHandleValue(rawValue, options);
    const hash = options.sha256Hex(normalized.normalizedValue);
    if (!CONTACT_HANDLE_HASH.test(hash)) {
        throw new TypeError("sha256Hex must return lower-case SHA-256 hex");
    }
    return {
        kind: normalized.kind,
        hash,
    };
}
function isMindsetContactHandle(value) {
    if (!isRecord(value))
        return false;
    return (CONTACT_HANDLE_KINDS.has(value.kind) &&
        typeof value.hash === "string" &&
        CONTACT_HANDLE_HASH.test(value.hash));
}
function normalizeMindsetContactPhone(rawValue, defaultRegion) {
    const compact = rawValue.replace(/[\s().-]/gu, "");
    if (CONTACT_HANDLE_E164_PHONE.test(compact))
        return compact;
    const digits = Array.from(rawValue)
        .filter((char) => /\p{Number}/u.test(char))
        .join("");
    const internationalDigits = digits.startsWith("00")
        ? digits.slice(2)
        : digits.startsWith("011")
            ? digits.slice(3)
            : null;
    const international = internationalDigits === null ? null : `+${internationalDigits}`;
    if (international !== null && CONTACT_HANDLE_E164_PHONE.test(international)) {
        return international;
    }
    const region = defaultRegion?.trim().toUpperCase();
    if (region !== undefined && CONTACT_HANDLE_NANP_REGIONS.has(region)) {
        const nanpDigits = digits.length === 10
            ? `1${digits}`
            : digits.length === 11 && digits.startsWith("1")
                ? digits
                : null;
        const normalized = nanpDigits === null ? null : `+${nanpDigits}`;
        if (normalized !== null && CONTACT_HANDLE_E164_PHONE.test(normalized)) {
            return normalized;
        }
    }
    const defaultRegionPhone = normalizeMindsetDefaultRegionPhone(digits, region);
    if (defaultRegionPhone !== null)
        return defaultRegionPhone;
    throw new TypeError("Phone numbers must use E.164 format");
}
function normalizeMindsetDefaultRegionPhone(digits, region) {
    if (region === undefined)
        return null;
    const metadata = CONTACT_HANDLE_DEFAULT_REGION_PHONE_METADATA.get(region);
    if (metadata === undefined)
        return null;
    const nationalDigits = digits.startsWith(metadata.callingCode) &&
        digits.length > metadata.callingCode.length
        ? digits.slice(metadata.callingCode.length)
        : digits.startsWith(metadata.nationalPrefix)
            ? digits.slice(metadata.nationalPrefix.length)
            : digits;
    if (nationalDigits.length < metadata.minNationalLength ||
        nationalDigits.length > metadata.maxNationalLength ||
        nationalDigits.startsWith("0")) {
        return null;
    }
    const normalized = `+${metadata.callingCode}${nationalDigits}`;
    return CONTACT_HANDLE_E164_PHONE.test(normalized) ? normalized : null;
}
function isNullableTimestamp(value) {
    return value === null || isTimestamp(value);
}
function derivePresentationAttachmentAccessibilityState(state) {
    assertAttachmentAccessibilityPresentationState(state);
    const label = attachmentKindLabel(state.kind);
    if (state.status === "READY") {
        return {
            version: exports.MINDSET_MESSAGE_ATTACHMENT_ACCESSIBILITY_VERSION,
            surface: "PRESENTATION",
            status: "READY",
            kind: state.kind,
            label: `${label} attachment`,
            hint: `Open ${label.toLowerCase()} attachment`,
            value: state.attachment === null
                ? null
                : formatAttachmentAccessibilityValue(state.attachment),
            role: state.kind === "IMAGE" ? "image" : "button",
            isInteractive: true,
            exposesMediaLocator: false,
        };
    }
    if (state.status === "BLOCKED") {
        return {
            version: exports.MINDSET_MESSAGE_ATTACHMENT_ACCESSIBILITY_VERSION,
            surface: "PRESENTATION",
            status: "BLOCKED",
            kind: state.kind,
            label: `Blocked ${label.toLowerCase()} attachment`,
            hint: "Attachment cannot be opened",
            value: state.reason,
            role: "text",
            isInteractive: false,
            exposesMediaLocator: false,
        };
    }
    if (state.status === "DELETED") {
        return {
            version: exports.MINDSET_MESSAGE_ATTACHMENT_ACCESSIBILITY_VERSION,
            surface: "PRESENTATION",
            status: "DELETED",
            kind: state.kind,
            label: `Deleted ${label.toLowerCase()} attachment`,
            hint: "Attachment preview removed",
            value: state.deletedAt,
            role: "text",
            isInteractive: false,
            exposesMediaLocator: false,
        };
    }
    if (state.status === "RETRYABLE") {
        return {
            version: exports.MINDSET_MESSAGE_ATTACHMENT_ACCESSIBILITY_VERSION,
            surface: "PRESENTATION",
            status: "RETRYABLE",
            kind: state.kind,
            label: `${label} attachment upload failed`,
            hint: "Retry attachment upload",
            value: state.reason,
            role: "button",
            isInteractive: true,
            exposesMediaLocator: false,
        };
    }
    throw new Error("Unsupported attachment presentation accessibility status");
}
function deriveTransferAttachmentAccessibilityState(state) {
    assertAttachmentAccessibilityTransferState(state);
    const label = attachmentKindLabel(state.kind);
    if (state.status === "QUEUED") {
        return {
            version: exports.MINDSET_MESSAGE_ATTACHMENT_ACCESSIBILITY_VERSION,
            surface: "TRANSFER",
            status: "QUEUED",
            kind: state.kind,
            label: `${label} attachment queued`,
            hint: "Cancel attachment upload",
            value: "0% uploaded",
            role: "button",
            isInteractive: true,
            exposesMediaLocator: false,
        };
    }
    if (state.status === "UPLOADING") {
        return {
            version: exports.MINDSET_MESSAGE_ATTACHMENT_ACCESSIBILITY_VERSION,
            surface: "TRANSFER",
            status: "UPLOADING",
            kind: state.kind,
            label: `${label} attachment uploading`,
            hint: "Cancel attachment upload",
            value: `${Math.round((state.progressRatio ?? 0) * 100)}% uploaded`,
            role: "progressbar",
            isInteractive: true,
            exposesMediaLocator: false,
        };
    }
    if (state.status === "CANCELLED") {
        return {
            version: exports.MINDSET_MESSAGE_ATTACHMENT_ACCESSIBILITY_VERSION,
            surface: "TRANSFER",
            status: "CANCELLED",
            kind: state.kind,
            label: `${label} attachment upload cancelled`,
            hint: "Retry attachment upload",
            value: state.cancelledAt,
            role: "button",
            isInteractive: true,
            exposesMediaLocator: false,
        };
    }
    if (state.status === "FAILED") {
        return {
            version: exports.MINDSET_MESSAGE_ATTACHMENT_ACCESSIBILITY_VERSION,
            surface: "TRANSFER",
            status: "FAILED",
            kind: state.kind,
            label: `${label} attachment upload failed`,
            hint: "Retry attachment upload",
            value: state.reason,
            role: "button",
            isInteractive: true,
            exposesMediaLocator: false,
        };
    }
    if (state.status === "CACHED") {
        return {
            version: exports.MINDSET_MESSAGE_ATTACHMENT_ACCESSIBILITY_VERSION,
            surface: "TRANSFER",
            status: "CACHED",
            kind: state.kind,
            label: `${label} attachment cached`,
            hint: `Open cached ${label.toLowerCase()} attachment`,
            value: state.attachment === null
                ? null
                : `${formatAttachmentAccessibilityValue(state.attachment)}; cache expires ${state.cacheExpiresAt}`,
            role: state.kind === "IMAGE" ? "image" : "button",
            isInteractive: true,
            exposesMediaLocator: false,
        };
    }
    throw new Error("Unsupported attachment transfer accessibility status");
}
function assertAttachmentAccessibilityPresentationState(state) {
    if (!isRecord(state) ||
        state.version !== exports.MINDSET_MESSAGE_ATTACHMENT_PRESENTATION_VERSION ||
        !MESSAGE_ATTACHMENT_KINDS.has(state.kind)) {
        throw new Error("Attachment accessibility requires presentation state");
    }
    if (state.attachment !== null && !isMindsetMessageAttachment(state.attachment)) {
        throw new Error("Attachment accessibility requires clean metadata");
    }
}
function assertAttachmentAccessibilityTransferState(state) {
    if (!isRecord(state) ||
        state.version !== exports.MINDSET_MESSAGE_ATTACHMENT_TRANSFER_VERSION ||
        !MESSAGE_ATTACHMENT_KINDS.has(state.kind) ||
        state.selectedByUser !== true ||
        state.permissionRequested !== false) {
        throw new Error("Attachment accessibility requires transfer state");
    }
    if (state.attachment !== null && !isMindsetMessageAttachment(state.attachment)) {
        throw new Error("Attachment accessibility requires clean metadata");
    }
    if (state.status === "UPLOADING" &&
        (typeof state.progressRatio !== "number" ||
            !Number.isFinite(state.progressRatio) ||
            state.progressRatio < 0 ||
            state.progressRatio > 1)) {
        throw new Error("Attachment accessibility requires valid upload progress");
    }
}
function attachmentKindLabel(kind) {
    if (kind === "IMAGE")
        return "Image";
    if (kind === "VIDEO")
        return "Video";
    if (kind === "AUDIO")
        return "Voice note";
    return "File";
}
function formatAttachmentAccessibilityValue(attachment) {
    return `${formatAttachmentByteSize(attachment.byteSize)} ${attachment.contentType}`;
}
function formatAttachmentByteSize(byteSize) {
    if (byteSize < 1024)
        return `${byteSize} B`;
    if (byteSize < MINDSET_MEBIBYTE) {
        return `${Math.round(byteSize / 1024)} KB`;
    }
    return `${Math.round(byteSize / MINDSET_MEBIBYTE)} MB`;
}
function assertAttachmentTransferKind(kind) {
    if (!MESSAGE_ATTACHMENT_KINDS.has(kind)) {
        throw new Error("Attachment transfer kind must be IMAGE, VIDEO, AUDIO, or FILE");
    }
}
function assertAttachmentTransferClientMessageId(clientMessageId) {
    if (!isNonEmptyString(clientMessageId)) {
        throw new Error("Attachment transfer clientMessageId is required");
    }
}
function assertAttachmentTransferProgress(byteSize, uploadedByteSize) {
    if (!Number.isSafeInteger(byteSize) || byteSize < 1) {
        throw new Error("Attachment transfer byteSize must be a positive integer");
    }
    if (!Number.isSafeInteger(uploadedByteSize) ||
        uploadedByteSize < 0 ||
        uploadedByteSize > byteSize) {
        throw new Error("Attachment transfer uploadedByteSize must be between 0 and byteSize");
    }
}
function assertAttachmentTransferUserSelection(selectedByUser, permissionRequested) {
    if (selectedByUser !== true) {
        throw new Error("Attachment transfer requires explicit user selection");
    }
    if (permissionRequested === true) {
        throw new Error("Attachment transfer must not request permissions from this boundary");
    }
}
function normalizeAttachmentClientReason(value, label) {
    const reason = value.trim();
    if (reason.length < 1 || reason.length > 255) {
        throw new Error(`${label} must be between 1 and 255 characters`);
    }
    return reason;
}
function isMindsetMessageAttachmentPolicy(value) {
    if (!isRecord(value))
        return false;
    return (MESSAGE_ATTACHMENT_KINDS.has(value.kind) &&
        typeof value.maxByteSize === "number" &&
        Number.isSafeInteger(value.maxByteSize) &&
        value.maxByteSize > 0 &&
        Array.isArray(value.allowedContentTypes) &&
        value.allowedContentTypes.length > 0 &&
        value.allowedContentTypes.every((contentType) => typeof contentType === "string" && contentType.length > 0));
}
function isMessageAttachmentUploadBlockedGate(value) {
    return (value === "MESSAGING_CAPABILITY" ||
        MINDSET_MESSAGE_ATTACHMENT_EXECUTION_BLOCKED_GATES.includes(value));
}
function isTimestamp(value) {
    return (typeof value === "string" &&
        value.trim().length > 0 &&
        Number.isFinite(Date.parse(value)));
}
function isNonEmptyString(value) {
    return typeof value === "string" && value.trim().length > 0;
}
function isRecord(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
//# sourceMappingURL=index.js.map